import React, { type FunctionComponent } from 'react'
import { CollectionsFormField } from 'domains/collections/components/collections-form/components/form-field/CollectionsFormField'
import { CollectionsFormInput } from 'domains/collections/components/collections-form/components/form-input/CollectionsFormInput'
import { type CollectionsRuleProps } from 'domains/collections/components/collections-form/components/rules/utils/CollectionsRules.types'

export const CollectionsRuleSearchTerm: FunctionComponent<CollectionsRuleProps> = ({
  register,
  formPrefix,
}) => (
  <React.Fragment>
    <CollectionsFormField>
      <CollectionsFormInput
        labelId="collectionsDomain.collectionsForm.section.rules.searchTerm.placeholder"
        errorMessage="collectionsDomain.collectionsForm.section.header.title.error.required"
        identifier={`${formPrefix}.searchTerm`}
        ref={register({ required: true })}
      />
    </CollectionsFormField>
  </React.Fragment>
)
